import { render, staticRenderFns } from "./TableServiceCenter.vue?vue&type=template&id=40f3cc2c&scoped=true"
import script from "./TableServiceCenter.vue?vue&type=script&lang=js"
export * from "./TableServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./TableServiceCenter.vue?vue&type=style&index=0&id=40f3cc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3cc2c",
  null
  
)

export default component.exports